import * as React from 'react';

import Label from 'af-components/LockedValue/Label';
import Pills from 'af-components/Pills/LockedList';

interface Props {
	label: string;
	items: Metadata[];
	labelKey: string;
	colorKey: string;
}

export default ({ label, items, labelKey, colorKey }: Props): React.JSX.Element => {
	return (
		<>
			<Label label={label} />
			<div className="locked-input__pills">
				<Pills
					colorKey={colorKey}
					emptyLabel="No skills available"
					items={items}
					labelKey={labelKey}
				/>
			</div>
		</>
	);
};
